<script setup lang="ts">
const aiStore = useAiSettingsStore();
const generateImageMetadata = ref(false);
const aiEnabled = computed(() => aiStore.aiEnabled);

async function postProcess(file: FileResource)
{
    if (generateImageMetadata.value && file)
    {
        try
        {
            if (file)
            {
                const validType = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/webp'];

                if (validType.includes(file.contentType))
                {
                    // await AiCoreImageMetadataService.genImageMetadataQueue(file.id);
                }
            }
        }
        catch
        {
            //
        }
    }
}

defineExpose({
    postProcess
});
</script>

<template>
    <!-- <div v-if="aiEnabled">
        <IdeoFormCheckbox v-model="generateImageMetadata">
            {{ $t('[[[Generuj metadane (AI)]]]') }}
        </IdeoFormCheckbox>
        <div class="ps-4 ms-1 mb-2 text-muted small">
            {{ $t('[[[Wygeneruj metadane dla przesyłanych obrazów]]]') }}
        </div>
    </div> -->
</template>
